// tslint:disable
export var ClaimJobType;
(function (ClaimJobType) {
    // IMS Medical Claim Feed
    ClaimJobType[ClaimJobType["ImsClaimFeed"] = 1] = "ImsClaimFeed";
    // IMS Reconciliation (Payment Batch) Feed
    ClaimJobType[ClaimJobType["ImsReconciliationFeed"] = 2] = "ImsReconciliationFeed";
})(ClaimJobType || (ClaimJobType = {}));
ClaimJobType['IMSCLAIMFEED'] = 1;
ClaimJobType['IMSRECONCILIATIONFEED'] = 2;
//# sourceMappingURL=ClaimJobType.js.map